import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComponentsModule } from '@jht/brand-components';
import { TranslateModule } from '@jht/brand-translate';
import { DirectivesModule } from '@jht/brand-directives';

import { FormSubmissionService } from './form-submission.service';
import { Config } from '../../config';
@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        ComponentsModule,
        DirectivesModule,
        TranslateModule,
    ],
    providers: [FormSubmissionService, { provide: 'config', useClass: Config }],
    exports: [],
})
export class FormSubmissionModule {}
